import { isEmpty } from '@terros/common'
import { useProfile } from '../user'
import { useFeature } from '../feature'
import { useWorkflows } from './list'

export const useCanAddWorkflow = (): boolean => {
  const { data: workflows } = useWorkflows()
  const { user } = useProfile()

  const { isEnabled: canHaveMultiple } = useFeature({
    featureId: 'Feature:WorkflowMultiple',
    placeholder: false,
  })

  if (isEmpty(workflows)) return true
  if (canHaveMultiple) return true

  return false
}
